<div class="row" *ngIf="deposites">
  <div class="col-12 ">
    <h1>Depozyty</h1>
  </div>
</div>



<div class="d-flex justify-content-center flex-nowrap" *ngIf="deposites && summary">
  <div class="text-white mx-2 p-2" *ngIf="deposites && deposites.length == 0">
    <div class="alert alert-dark mt-3 mb-3"><h3>Brak dostępnych depozytów.</h3></div>
  </div>

  <div class="desktop-only text-white mx-2 p-2" *ngIf="deposites.length > 0">
    <table class="table table-striped table-responsive-lg table-hover table-sm small">
      <thead>
        <tr>
          <th>#</th>
          <th>Opony</th>
          <th colspan="4">Serwis</th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let deposite of deposites; let i = index;" [ngStyle]="summary.CurrentGarageVisit &&  summary.CurrentGarageVisit.TyreFromDepositeId == deposite.DepositeId ? {'background-color': '#00bd3f', 'color':'#fff'} : {}">

          <td>{{i+1}}</td>
          <td class="text-left">{{ deposite.Tyre }} x {{deposite.TyreCount}}</td>
          <td>{{ deposite.Garage.Name}}</td>
          <td>{{ deposite.Garage.City}}</td>
          <td>{{ deposite.Garage.Street}}</td>
          <td>{{ deposite.Garage.Telephone}}</td>
          <td><i *ngIf="deposite.IsAldGarageVisitAvailable" class="fa fa-calendar" aria-hidden="true" (click)="onDepositeVisit(deposite)"></i></td>
          <td><i *ngIf="deposite.IsAldGarageVisitRequestAvailable" class="fa fa-bell" aria-hidden="true" (click)="onDepositeVisitRequest(deposite)"></i></td>
          <td><i *ngIf="deposite.IsAldRelocationAvailable" class="fa fa-share-square-o" aria-hidden="true" (click)="onDepositeRelocate(deposite)"></i></td>
          <td><i *ngIf="deposite.IsAnyTyreBlockedByOrder" class="fa fa-thumb-tack" aria-hidden="true" style="color:darkred"></i></td>
        </tr>
      </tbody>
      <tfoot class="table-legend">
        <tr><td class="firt-legend-row"></td></tr>
        <tr>
          <td><i class="fa fa-calendar" aria-hidden="true"></i></td>
          <td colspan="8">
            {{toolTipGarageVisit}}
          </td>
        </tr>

        <tr>
          <td><i class="fa fa-bell" aria-hidden="true"></i></td>
          <td colspan="8">
            {{toolTipGarageVisitRequest}}
          </td>
        </tr>

        <tr>
          <td><i class="fa fa-share-square-o" aria-hidden="true"></i></td>
          <td colspan="8">
            {{toolTipRelocation}}
          </td>
        </tr>

        <tr>
          <td><i class="fa fa-thumb-tack" aria-hidden="true" style="color:darkred"></i></td>
          <td colspan="8">
            {{toolDepositeInOrder}}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="mobile-only text-white mx-2 p-2" *ngIf="deposites.length > 0">
    <table class="table table-striped table-responsive-lg table-hover table-sm small">
      <thead>
        <tr>
          <th>#</th>
          <th>Opony</th>
          <th>Serwis</th>
          <th></th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let deposite of deposites; let i = index;" [ngStyle]="summary.CurrentGarageVisit &&  summary.CurrentGarageVisit.TyreFromDepositeId == deposite.DepositeId ? {'background-color': '#00bd3f', 'color':'#fff'} : {}">

          <td>{{i+1}}</td>
          <td class="text-left">{{ deposite.Tyre }} x {{deposite.TyreCount}}</td>
          <td>
            <div>{{ deposite.Garage.Name}}</div>
            <div>{{ deposite.Garage.City}}</div>
            <div>{{ deposite.Garage.Street}}</div>
            <div>{{ deposite.Garage.Telephone}}</div>
          <td>
            <table class="icons">
              <tr *ngIf="deposite.IsAldGarageVisitAvailable">
                <td>
                  <i class="fa fa-calendar fa-2xl" aria-hidden="true" (click)="onDepositeVisit(deposite)"></i>
                </td>
              </tr>

              <tr *ngIf="deposite.IsAldGarageVisitRequestAvailable">
                <td class="pt-3">
                  <i class="fa fa-bell fa-2xl" aria-hidden="true" (click)="onDepositeVisitRequest(deposite)"></i>
                </td>
              </tr>

              <tr *ngIf="deposite.IsAldRelocationAvailable">
                <td class="pt-3">
                  <i class="fa fa-share-square-o fa-2xl" aria-hidden="true" (click)="onDepositeRelocate(deposite)"></i>
                </td>
              </tr>

              <tr *ngIf="deposite.IsAnyTyreBlockedByOrder">
                <td class="pt-3">
                  <i  class="fa fa-thumb-tack fa-2xl" aria-hidden="true" style="color:darkred"></i>
                </td>
              </tr>
            </table>
         </td>
        </tr>
      </tbody>
      <tfoot class="table-legend">
        <tr><td class="firt-legend-row"></td></tr>
        <tr>
          <td class="firt-legend-row"><i class="fa fa-calendar firt-legend-row" aria-hidden="true"></i></td>
          <td colspan="5">
            {{toolTipGarageVisit}}
          </td>
        </tr>

        <tr>
          <td><i class="fa fa-bell" aria-hidden="true"></i></td>
          <td colspan="8">
            {{toolTipGarageVisitRequest}}
          </td>
        </tr>

        <tr>
          <td><i class="fa fa-share-square-o" aria-hidden="true"></i></td>
          <td colspan="8">
            {{toolTipRelocation}}
          </td>
        </tr>

        <tr>
          <td><i class="fa fa-thumb-tack" aria-hidden="true" style="color:darkred"></i></td>
          <td colspan="8">
            {{toolDepositeInOrder}}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>


<div class="container z-index-master" *ngIf="!deposites || !summary">
  <div class="row align-items-center">
    <div class="col-md-12">
      <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>
